<template>
  <v-tooltip
    top
    max-width="400"
  >
    <template v-slot:activator="{ on: onTooltip }">
      <div v-on="{ ...onTooltip }">
        <v-select
          v-model="value.selecionado"
          :items="value.lista"
          label="Ordenar por:"
          item-text="descricao"
          :prepend-icon="value.decrescente ? 'south' : 'north'"
          :dense="dense"
          return-object
          @input="change"
          @click:prepend="change"
        />
      </div>
    </template>
    <span>Selecione para ordenar os dados</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'AppSort',

  props: {
    value: {
      type: Object,
      default: () => ({
        decrescente: false,
        ordenarPor: '',
        selecionado: null,
        lista: [],
      }),
      required: true,
    },
    dense: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    change() {
      if (this.value.ordenarPor === this.value.selecionado.id) {
        this.value.decrescente = !this.value.decrescente;
      } else {
        this.value.ordenarPor = this.value.selecionado.id;
        this.value.decrescente = !this.value.decrescente;
      }
    },
  },
};
</script>
